/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersQuery } from '../../models/get-orders-query';
import { GetOrdersQueryResult } from '../../models/get-orders-query-result';

export interface ApiNurseryManagerOrdersGetOrdersPost$Params {
      body?: GetOrdersQuery
}

export function apiNurseryManagerOrdersGetOrdersPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersGetOrdersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersGetOrdersPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersQueryResult>;
    })
  );
}

apiNurseryManagerOrdersGetOrdersPost.PATH = '/api/NurseryManager/Orders/GetOrders';
